import { render, staticRenderFns } from "./PortalDocumentosExterno.vue?vue&type=template&id=bb95d8a0"
import script from "./PortalDocumentosExterno.vue?vue&type=script&lang=js"
export * from "./PortalDocumentosExterno.vue?vue&type=script&lang=js"
import style0 from "./PortalDocumentosExterno.vue?vue&type=style&index=0&id=bb95d8a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports